import axios from 'axios';
import log from '../../logger';

/**
 * The CMS config, from `/config/config.json`.
 *
 * Replaces Angular's `configService`, which cached a single `$q` deferred for the life of the
 * page and exposed `reset()` for the auth screens to call after a password change, since the
 * config a logged-out visitor gets differs from a logged-in admin's.
 *
 * Kept as a module-level promise rather than React state because three different things need
 * it before any component has mounted: the router's home redirect, the frame, and the auth
 * screens. A hook is layered on top for components that want it.
 */
let pending = null;

export function getConfig() {
  if (!pending) {
    pending = axios
      .get('/config/config.json')
      .then(({ data }) => data)
      .catch((error) => {
        pending = null;
        log.error('Failed to get config', error);
        throw new Error('Failed to get config.');
      });
  }
  return pending;
}

/**
 * Drop the cached config so the next read refetches.
 *
 * This is `configService.reset`, and the auth screens call it as `resetConfig` after changing
 * a password or registering. Renamed here because "reset the config" reads like it changes
 * the tenant's configuration, which it emphatically does not.
 */
export function resetConfigCache() {
  pending = null;
}
